import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getAuditLogPath = () => urlHelper('/audit-log');
